









































































































import Vue from 'vue';
import Component from 'vue-class-component';
import { Watch } from 'vue-property-decorator';
import { VueEasyJwt } from 'vue-easy-jwt';

const jwt = new VueEasyJwt();

// TODO: Mover a una librería de tipos de la aplicación.
interface IToken {
    id: number;
    username: string;
    customerId: number | null;
    password: string;
}

@Component
export default class PasswordRecovery extends Vue {
    loadingForm: boolean = false;
    snackbarError: boolean = false;
    snackbarText: string = '';
    snackbarColor: string = '';
    timeout: number = 3000;
    disableButton: boolean = false;
    email: string = '';
    customerName: string = '';
    password: string = '';
    confirmationPassword: string = '';
    showConfirmationPassword: boolean = false;
    showPassword: boolean = false;
    rules: {
        defaultRules: any[];
        passwordRules: any[];
    } = {
        defaultRules: [(v: any) => !!v || 'Requerido'],
        passwordRules: [
            (v: any) => !v || /^\S+$/.test(v) || 'No se admiten espacion en blancos',
            (v: any) => !v || v.length > 7 || 'La contraseña debe tener mínimo 8 caracteres',
        ],
    };

    $refs!: {
        form1: any;
    };

    async mounted() {
        this.email = this.$store.state.dataForPasswordRecovery.username;
        await this.getCustomerInfo();
    }

    async getCustomerInfo() {
        await this.$store.dispatch('getCustomerInfo', {
            id: this.$store.state.dataForPasswordRecovery.id,
        });
        if (!this.getCustomerInfoFailed) {
            if (this.$store.state.customerName.customer) {
                this.customerName = this.$store.state.customerName.customer.name;
            }
        } else {
            this.openSnackbar('Ocurrió un error obteniendo el nombre del cliente', 'error');
        }
    }

    @Watch('confirmationPassword')
    onConfirmationPasswordChanged() {
        this.validatePassword();
    }
    @Watch('password')
    onPasswordChanged() {
        if (!this.password) {
            this.confirmationPassword = '';
        }
    }

    async changePassword() {
        if (!this.disableButton) {
            if (this.$refs.form1.validate() && this.confirmationPassword) {
                this.loadingForm = true;
                const data: {
                    token: string | null;
                    dataToSend: {
                        id: number;
                        username: string;
                        customerId: number | null;
                        password: string;
                    };
                } = {
                    token: this.$store.state.dataForPasswordRecovery.token,
                    dataToSend: {
                        id: this.$store.state.dataForPasswordRecovery.id,
                        username: this.$store.state.dataForPasswordRecovery.username,
                        customerId: this.$store.state.dataForPasswordRecovery.customerId,
                        password: this.password,
                    },
                };
                await this.$store.dispatch('resetPassword', data);
                this.loadingForm = false;
                if (!this.passwordResetFailed) {
                    this.openSnackbar(`Su contraseña fue restablecida exitosamente`, 'green');
                    this.disableButton = true;
                    setTimeout(() => {
                        this.$router.push({ name: 'login' });
                    }, this.timeout);
                } else {
                    this.openSnackbar('Ocurrió un error, por favor intente de nuevo', 'error');
                }
            } else {
                this.validatePassword();
                this.openSnackbar('Verifique su contraseña', 'error');
            }
        }
    }
    get passwordResetFailed() {
        if (this.$store.state.failedPasswordRecoveryTransaction === 'ResetPassword') {
            return true;
        } else {
            return false;
        }
    }
    get getCustomerInfoFailed() {
        if (this.$store.state.failedPasswordRecoveryTransaction === 'CustomerInfo') {
            return true;
        } else {
            return false;
        }
    }
    validatePassword() {
        this.$refs.form1.validate();
        if (!this.password) {
            this.confirmationPassword = '';
        }
    }

    openSnackbar(message: string, color: string) {
        this.closeSnackbar();
        this.snackbarText = message;
        this.snackbarColor = color;
        this.snackbarError = true;
    }

    closeSnackbar() {
        this.snackbarError = false;
        this.snackbarText = '';
    }

    get PasswordMatchRules() {
        const rules = [
            this.rules.passwordRules[0],
            this.rules.passwordRules[1],
            this.rules.defaultRules[0],
        ];
        if (this.confirmationPassword) {
            const rule = (v: any) =>
                (!!v && v) == this.confirmationPassword || 'Las contraseñas no coinciden';
            rules.push(rule);
        }
        return rules;
    }

    beforeCreate() {
        const resetToken: any = this.$route.query.reset_token;
        this.$router.replace({ path: '/password-recovery' });

        if (!jwt.isExpired(resetToken)) {
            // TODO: Se hace una conversión a la fuerza, para respetar los tipos de datos de la librería EasyJWT
            const decodedToken = (jwt.decodeToken(resetToken) as unknown) as IToken;
            this.$store.commit('SET_DATA_FOR_PASSWORD_RECOVERY', {
                id: decodedToken.id,
                token: resetToken,
                username: decodedToken.username,
                customerId: decodedToken.customerId,
            });
        } else {
            this.$router.push({ name: 'login' });
        }
    }
}
